module.exports = __webpack_public_path__ + "media/images/login--4575a228.png";